import { PottedPlant, type PlantVariant } from '../parts/greenery'
import type { AssetContext, AssetDefinition } from '../types'

/** REFERENCE ASSET — the minimal shape of a catalog entry with variants. */
function PlantFloor({ variant = 'tall' }: AssetContext) {
  return <PottedPlant variant={variant as PlantVariant} />
}

export const definition: AssetDefinition = {
  id: 'plant-floor',
  name: 'Planta de piso',
  category: 'decor',
  footprint: [0.7, 0.7],
  height: 1.05,
  variants: [
    { id: 'tall', name: 'Hojas grandes' },
    { id: 'bushy', name: 'Frondosa' },
    { id: 'blades', name: 'Lengua de suegra' },
  ],
  keywords: ['planta', 'maceta', 'verde', 'plant', 'pot'],
  Component: PlantFloor,
}
